import type { AppThunk } from "@Store/index";
import { fetchAuthorPageData } from "./authorPageReducer";

const loadData = (props: any): AppThunk[] => [fetchAuthorPageData(props)];

export default loadData;
